// @flow
import React from 'react'
import classNames from 'classnames'
import { Loader as LoaderLib } from 'react-loaders'

type LoaderProps = {
  active: boolean,
  cover: boolean,
  fullScreen?: boolean,
  small: boolean,
  type: string,
}

export default class Loader extends React.PureComponent<LoaderProps> {
  static defaultProps = {
    fullScreen: false,
    type: 'ball-clip-rotate',
  }

  render() {
    const { active, cover, small, fullScreen, type } = this.props
    if (!active) {
      return null
    }
    const classes = ['react-loader position-absolute d-flex align-items-center justify-content-center h-100 w-100']
    if (fullScreen) {
      classes.push('react-loader-fullscreen bg-faded')
    } else if (cover) {
      classes.push('react-loader react-loader-cover-parent')
    }

    const loaderWrapperClasses = ['loader loader-primary']
    if (small) {
      loaderWrapperClasses.push('loader loader-sm loader-default')
    }

    return (
      <div className={classNames(classes)} style={{ top: 0, left: 0 }}>
        <div className={classNames(loaderWrapperClasses)}>
          <LoaderLib active type={type} />
        </div>
      </div>
    )
  }
}
